<template>
  <d2-container>
    <el-button
      class="filter-item"
      type="primary"
      v-permission:function="['taskClassificationManger:btn_add']"
      size="mini"
      icon="el-icon-circle-plus"
      @click="getAdd"
    >添加</el-button>
    <el-table
      size="small"
      :key="tableKey"
      stripe
      border
      highlight-current-row
      style=" margin-top: 20px"
      :data="cardData"
    >
      <el-table-column align="center" label="标签id">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="标签名称">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="标签横幅">
        <template slot-scope="scope">
          <img :src="scope.row.banner" style="width: 100px; height: 50px;" />
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" fixed="right" width="420">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="primary"
            @click="editCard(scope.row.id)"
            style="margin-top: 10px;"
            v-permission:function="['taskClassificationManger:btn_edit']"
          >编辑</el-button>
          <el-button
            size="small"
            type="danger"
            @click="delCard(scope.row.id)"
            v-permission:function="['taskClassificationManger:btn_del']"
            style="margin-top: 10px;"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <template slot="footer">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="listQuery.currentPage"
        :page-sizes="[10,20,30, 50]"
        :page-size="listQuery.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="width:500px"
      ></el-pagination>
    </template>
    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
      <el-form :model="form" :rules="rules" ref="form" label-width="170px">
        <el-form-item label="标签名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入标签名称"></el-input>
        </el-form-item>
<!--     标签横幅   -->
        <el-form-item label="标签横幅" prop="banner">
          <uploadImg
            v-model="form.banner"
            :imgSize="1"
            :text="['图片大小500kb以内', '图片格式png/jpg/gif']"
          ></uploadImg>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('form')">取 消</el-button>
        <el-button v-if="dialogStatus=='create'" type="primary" @click="create('form')">确 定</el-button>
        <el-button v-else type="primary" @click="update('form')">确 定</el-button>
      </div>
    </el-dialog>
  </d2-container>
</template>
<script>
import { mapGetters } from 'vuex'
import uploadImg from '@/components/uploadImage/index.vue'
import {
  getAddTap,
  getTagys,
  tagUpdate,
  tagInfo,
  tagRemove
} from '@/api/demo/task/index'
export default {
  name: 'taskClassificationManger',
  computed: {
    ...mapGetters(['elements'])
  },
  components: {
    uploadImg
  },
  data () {
    return {
      taskClassificationManger_btn_add: false,
      taskClassificationManger_btn_edit: false,
      taskClassificationManger_btn_del: false,

      tableKey: 0,
      listQuery: {
        currentPage: 1,
        pageSize: 20
      },
      selectedTime: [], // 时间
      cardData: [], // 表格数据
      total: null,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '创建'
      },
      dialogFormVisible: false,
      form: {
        name: '',
        banner: ''
      },
      rules: {
        name: [
          {
            required: true,
            message: '请输入标签名称',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur'
          }
        ]
      },
      classId: null // 分类id
    }
  },
  watch: {
    $route (to, from) {
      this.getSearch()
    }
  },
  created () {
    this.getSearch()
  },
  mounted () {},
  methods: {
    // 搜索条件
    getSearch (val) {
      if (val) {
        this.listQuery.currentPage = val
      } else {
        this.listQuery.currentPage = 1
      }
      getTagys(this.listQuery).then(res => {
        this.listLoading = true
        this.cardData = res.records
        console.log(this.$data, this.$options.data())
        this.total = parseInt(res.total)
        this.listLoading = false
      })
    },
    // 添加
    getAdd () {
      this.dialogStatus = 'create'
      this.form.name = ''
      this.dialogFormVisible = true
    },
    // 编辑
    editCard (id) {
      let that = this
      that.dialogFormVisible = true
      that.dialogStatus = 'update'
      tagInfo(id).then(res => {
        console.log('id', res)
        that.form = res
        that.classId = id
      })
    },
    delCard (id) {
      let that = this
      this.$confirm('此操作将删除该分类, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          tagRemove(id).then(res => {
            that.getSearch()
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
          })
        })
        .catch(() => {
          that.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 添加
    create (formName) {
      let that = this
      const set = that.$refs
      set[formName].validate(valid => {
        if (valid) {
          getAddTap(that.form).then(res => {
            that.getSearch()
            that.$message({
              message: '新增成功',
              type: 'success',
              center: true
            })
            that.dialogFormVisible = false
          })
        } else {
          return false
        }
      })
    },
    // 编辑
    update (formName) {
      let that = this
      const set = that.$refs
      set[formName].validate(valid => {
        if (valid) {
          tagUpdate(that.form, that.classId).then(res => {
            that.getSearch()
            that.$message({
              message: '修改成功',
              type: 'success',
              center: true
            })
            that.dialogFormVisible = false
          })
        } else {
          return false
        }
      })
    },
    // 取消
    cancel (formName) {
      this.dialogFormVisible = false
      this.$refs[formName].resetFields()
    },
    // 每页条数
    handleSizeChange (val) {
      this.listQuery.pageSize = val
      this.getSearch(val)
    },
    // 当前页
    handleCurrentChange (val) {
      this.listQuery.currentPage = val
      this.getSearch(val)
    }
  }
}
</script>

<style scoped>
</style>
